var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b;
import { createSelector } from 'reselect';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCollectionProgress } from '../../api/collections';
import { createReducer } from '../../reducers/factory';
import { loggedSelector } from '../../selectors';
import { EOwnedCollectionStatus, isProgressItemFetched, } from './types';
import { anyCardGroupIncludesCard, collectionProgressFetchErrors, collectionProgressName, FETCH_COLLECTION_PROGRESS_FAILED_REGIONAL, HIDE_COLLECTION, REMOVE_CARDS_FROM_COLLECTIONS, } from './utils';
import { fetchCountryIfNeeded } from '../../actions/CountryActions';
import { updateOwnedCollection } from './ownedCollections';
import { MINUTE_MS, SECOND_MS } from '../../time';
import { filterObject, isEmptyObject, mapObject } from '../../utils/records';
import { SET_COLLECTION_OF_CARD } from '../cards';
var name = collectionProgressName;
var FETCH_COLLECTION_PROGRESS_SUCCESSFUL = 'FETCH_COLLECTION_PROGRESS_SUCCESSFUL';
var FETCH_COLLECTION_PROGRESS_FAILED = 'FETCH_COLLECTION_PROGRESS_FAILED';
var FETCH_COLLECTION_PROGRESS_IN_PROGRESS = 'FETCH_COLLECTION_PROGRESS_IN_PROGRESS';
export var INVALIDATE = "INVALIDATE_".concat(name);
var UPDATE_SLOTS_AFTER_SAVE = 'UPDATE_SLOTS_AFTER_SAVE';
var UPDATE_COLLECTION_AFTER_SAVE = 'UPDATE_COLLECTION_AFTER_SAVE';
var SET_COLLECTION_PROGRESS_STATUS = 'SET_COLLECTION_PROGRESS_STATUS';
var itemWithReplacedSlots = function (item, _a) {
    var getNewSlots = _a.getNewSlots, createProgressObjectIfMissing = _a.createProgressObjectIfMissing;
    if (!isProgressItemFetched(item)) {
        return item;
    }
    if (item.progress && item.progress.slots) {
        return __assign(__assign({}, item), { progress: __assign(__assign({}, item.progress), { slots: getNewSlots(item.progress.slots) }) });
    }
    if (createProgressObjectIfMissing) {
        return __assign(__assign({}, item), { progress: {
                _id: '',
                slots: getNewSlots(),
                collectionCampaign: item.collection._id,
                status: EOwnedCollectionStatus.IN_PROGRESS,
            } });
    }
    return item;
};
var itemWithMappedCards = function (item, mapCard) {
    var _a;
    if (!isProgressItemFetched(item) || !((_a = item.cards) === null || _a === void 0 ? void 0 : _a.length)) {
        return item;
    }
    return __assign(__assign({}, item), { cards: item.cards.map(mapCard) });
};
var itemWithFilteredCards = function (item, cardsFilter) {
    var _a;
    if (!isProgressItemFetched(item) || !((_a = item.cards) === null || _a === void 0 ? void 0 : _a.length)) {
        return item;
    }
    return __assign(__assign({}, item), { cards: item.cards.filter(function (card) { return cardsFilter(card._id); }) });
};
var withStatusUpdated = function (item, status) {
    if (!isProgressItemFetched(item) || !item.progress) {
        return item;
    }
    return __assign(__assign({}, item), { progress: __assign(__assign({}, item.progress), { status: status }) });
};
var withMarkedAsHidden = function (item) {
    if (!isProgressItemFetched(item)) {
        return item;
    }
    if (!item.progress) {
        return __assign(__assign({}, item), { didInvalidate: true });
    }
    return __assign(__assign({}, item), { progress: __assign(__assign({}, item.progress), { hidden: true }) });
};
var withCardsRemoved = function (state, cardIds) { return (__assign(__assign({}, state), { items: __assign({}, Object.keys(state.items).reduce(function (acc, collectionId) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[collectionId] = itemWithReplacedSlots(itemWithFilteredCards(state.items[collectionId], function (cardId) { return !cardIds.includes(cardId); }), {
            getNewSlots: function (oldSlots) {
                return oldSlots.filter(function (slot) {
                    return isEmptyObject(slot) ||
                        !slot.card ||
                        !cardIds.includes(slot.card);
                });
            },
        }), _a)));
    }, {})) })); };
var withoutFailedCollection = function (state, idOrAlias) {
    var _a;
    var items = state.items, aliases = state.aliases;
    var failedCollectionId = (_a = aliases[idOrAlias]) !== null && _a !== void 0 ? _a : idOrAlias;
    return __assign(__assign({}, state), { items: filterObject(items, function (itemsKey) { return itemsKey !== failedCollectionId; }) });
};
var invalidated = function (state) {
    var updatedItems = {};
    Object.keys(state.items).forEach(function (key) {
        updatedItems[key] = __assign(__assign({}, state.items[key]), { didInvalidate: true });
    });
    return __assign(__assign({}, state), { items: updatedItems });
};
var cardsCollectionsProgressReducer = createReducer('CARDS_COLLECTIONS_PROGRESS', {
    fetchTimeout: 30 * SECOND_MS,
    resetActions: ['LOGOUT_SUCCESSFUL'],
    extendedReducer: (_a = {},
        _a[FETCH_COLLECTION_PROGRESS_SUCCESSFUL] = function (state, action) {
            var _a;
            var newState = __assign(__assign({}, state), { aliases: __assign(__assign({}, state.aliases), (_a = {}, _a[action.collectionProgress.collection.urlAlias] = action.collectionProgress.collection._id, _a)) });
            // During fetching the alias might have been used as a key, but now we want to make sure that
            // there's only one object, and it's stored with an id as the key.
            delete newState.items[action.idOrAlias];
            newState.items[action.collectionProgress.collection._id] = __assign(__assign({}, action.collectionProgress), { lastSuccessfulFetch: action.timestamp, fetchPromise: null, fetchingInProgressSince: null, didInvalidate: false });
            return newState;
        },
        _a[FETCH_COLLECTION_PROGRESS_FAILED] = function (state, action) {
            var _a;
            return (__assign(__assign({}, state), { items: __assign(__assign({}, state.items), (_a = {}, _a[action.idOrAlias] = __assign(__assign({}, state.items[action.idOrAlias]), { fetchingInProgressSince: null, lastFailedFetch: action.timestamp, fetchPromise: null }), _a)) }));
        },
        _a[FETCH_COLLECTION_PROGRESS_IN_PROGRESS] = function (state, action) {
            var _a;
            return (__assign(__assign({}, state), { items: __assign(__assign({}, state.items), (_a = {}, _a[action.idOrAlias] = __assign(__assign({}, state.items[action.idOrAlias]), { fetchingInProgressSince: action.timestamp, fetchPromise: action.fetchPromise }), _a)) }));
        },
        _a[INVALIDATE] = function (state) { return invalidated(state); },
        _a.SET_LANGUAGE = function (state) { return invalidated(state); },
        _a.LOGIN_SUCCESSFUL = function (state) { return invalidated(state); },
        _a.SHRED_CARD_SUCCESSFUL = function (state, action) {
            return action.cardId ? withCardsRemoved(state, [action.cardId]) : state;
        },
        _a.SHRED_CARDS_SUCCESSFUL = function (state, action) { var _a; return withCardsRemoved(state, (_a = action.cardsIds) !== null && _a !== void 0 ? _a : []); },
        _a[REMOVE_CARDS_FROM_COLLECTIONS] = function (state, action) { var _a; return withCardsRemoved(state, (_a = action.cardsIds) !== null && _a !== void 0 ? _a : []); },
        _a.ADD_CARDS = function (state, action) { return (__assign(__assign({}, state), { items: Object.keys(state.items).reduce(function (newItems, collectionId) {
                var _a, _b, _c;
                var _d;
                var progressItem = state.items[collectionId];
                if (!isProgressItemFetched(progressItem)) {
                    return __assign(__assign({}, newItems), (_a = {}, _a[collectionId] = progressItem, _a));
                }
                var newCardsRelatedToCollection = action.cards.filter(function (card) {
                    return anyCardGroupIncludesCard(progressItem.collection.cardGroups, card.cardTemplate._id);
                });
                if (!newCardsRelatedToCollection.length) {
                    return __assign(__assign({}, newItems), (_b = {}, _b[collectionId] = progressItem, _b));
                }
                return __assign(__assign({}, newItems), (_c = {}, _c[collectionId] = __assign(__assign({}, progressItem), { cards: __spreadArray(__spreadArray([], newCardsRelatedToCollection.map(function (card) { return ({
                        _id: card._id,
                        cardTemplate: card.cardTemplate,
                    }); }), true), ((_d = progressItem.cards) !== null && _d !== void 0 ? _d : []), true) }), _c));
            }, {}) })); },
        _a[UPDATE_SLOTS_AFTER_SAVE] = function (state, action) {
            var _a;
            return (__assign(__assign({}, state), { items: __assign(__assign({}, state.items), (_a = {}, _a[action.collectionId] = itemWithReplacedSlots(state.items[action.collectionId], {
                    createProgressObjectIfMissing: true,
                    getNewSlots: function () { return action.slots; },
                }), _a)) }));
        },
        _a[UPDATE_COLLECTION_AFTER_SAVE] = function (state, action) {
            var _a;
            return (__assign(__assign({}, state), { items: __assign(__assign({}, state.items), (_a = {}, _a[action.collection._id] = __assign(__assign({}, state.items[action.collection._id]), { collection: action.collection }), _a)) }));
        },
        _a[SET_COLLECTION_PROGRESS_STATUS] = function (state, action) {
            var _a;
            return (__assign(__assign({}, state), { items: __assign(__assign({}, state.items), (_a = {}, _a[action.collectionId] = withStatusUpdated(state.items[action.collectionId], action.status), _a)) }));
        },
        _a[HIDE_COLLECTION] = function (state, action) {
            var _a;
            return (__assign(__assign({}, state), { items: __assign(__assign({}, state.items), (_a = {}, _a[action.collectionId] = withMarkedAsHidden(state.items[action.collectionId]), _a)) }));
        },
        _a[SET_COLLECTION_OF_CARD] = function (state, action) { return (__assign(__assign({}, state), { items: mapObject(state.items, function (_, item) {
                return itemWithMappedCards(item, function (card) {
                    return card._id === action.cardId
                        ? __assign(__assign({}, card), { cardCollection: action.collectionId }) : card;
                });
            }) })); },
        _a[FETCH_COLLECTION_PROGRESS_FAILED_REGIONAL] = function (state, action) {
            return withoutFailedCollection(state, action.idOrAlias);
        },
        _a),
    minUpdate: 2 * MINUTE_MS,
    initialState: {
        aliases: {},
    },
});
var fetchCollectionSuccessful = function (collectionProgress, idOrAlias) { return ({
    type: FETCH_COLLECTION_PROGRESS_SUCCESSFUL,
    collectionProgress: collectionProgress,
    timestamp: Date.now(),
    idOrAlias: idOrAlias,
}); };
cardsCollectionsProgressReducer.fetchFailed = function (reason, idOrAlias) { return ({
    type: FETCH_COLLECTION_PROGRESS_FAILED,
    reason: reason,
    timestamp: Date.now(),
    idOrAlias: idOrAlias,
}); };
cardsCollectionsProgressReducer.fetchInProgress = function (fetchPromise, idOrAlias) { return ({
    type: FETCH_COLLECTION_PROGRESS_IN_PROGRESS,
    fetchPromise: fetchPromise,
    timestamp: Date.now(),
    idOrAlias: idOrAlias,
}); };
var failRegionalFetch = function (idOrAlias) { return ({
    type: FETCH_COLLECTION_PROGRESS_FAILED_REGIONAL,
    idOrAlias: idOrAlias,
}); };
export var collectionsProgressPlainSelector = function (_a) {
    var _b = name, cardsCollectionsProgress = _a[_b];
    return cardsCollectionsProgress;
};
export var fetchCollectionProgressAction = function (idOrAlias) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var fetchPromise;
    return __generator(this, function (_a) {
        fetchPromise = (function () { return __awaiter(void 0, void 0, void 0, function () {
            var state, _a, apiUrl, token, country, res, e_1, messageId;
            var _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 3, , 4]);
                        state = getState();
                        _a = state.auth, apiUrl = _a.apiUrl, token = _a.token;
                        return [4 /*yield*/, dispatch(fetchCountryIfNeeded())];
                    case 1:
                        country = _e.sent();
                        return [4 /*yield*/, fetchCollectionProgress(apiUrl, token, idOrAlias, country)];
                    case 2:
                        res = _e.sent();
                        dispatch(fetchCollectionSuccessful(res, idOrAlias));
                        if (res.progress) {
                            dispatch(updateOwnedCollection(res.collection, (_b = res.progress) === null || _b === void 0 ? void 0 : _b.status, (_c = res.progress) === null || _c === void 0 ? void 0 : _c.slots, (_d = res.progress) === null || _d === void 0 ? void 0 : _d._id));
                        }
                        return [2 /*return*/, res];
                    case 3:
                        e_1 = _e.sent();
                        messageId = e_1.messageId;
                        if (messageId === collectionProgressFetchErrors.notAvailableForRegion) {
                            dispatch(failRegionalFetch(idOrAlias));
                        }
                        dispatch(cardsCollectionsProgressReducer.fetchFailed(e_1, idOrAlias));
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
        dispatch(cardsCollectionsProgressReducer.fetchInProgress(fetchPromise, idOrAlias));
        return [2 /*return*/, fetchPromise];
    });
}); }; };
export var collectionsProgressDetailsSelector = createSelector([
    collectionsProgressPlainSelector,
    function (_, idOrAlias) { return idOrAlias; },
], function (_a, idOrAlias) {
    var items = _a.items, aliases = _a.aliases;
    return aliases[idOrAlias] ? items[aliases[idOrAlias]] : items[idOrAlias];
});
export var fetchCollectionProgressIfNeeded = function (idOrAlias) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var progressFetched;
    var _a;
    return __generator(this, function (_b) {
        progressFetched = collectionsProgressDetailsSelector(getState(), idOrAlias);
        if (cardsCollectionsProgressReducer.shouldFetch(progressFetched)) {
            return [2 /*return*/, dispatch(fetchCollectionProgressAction(idOrAlias))];
        }
        return [2 /*return*/, typeof ((_a = progressFetched === null || progressFetched === void 0 ? void 0 : progressFetched.fetchPromise) === null || _a === void 0 ? void 0 : _a.then) === 'function'
                ? progressFetched.fetchPromise
                : progressFetched];
    });
}); }; };
export var updateSlotsAfterSave = function (collectionId, slots) { return ({
    type: UPDATE_SLOTS_AFTER_SAVE,
    collectionId: collectionId,
    slots: slots,
}); };
export var updateCollectionAfterSave = function (collection) { return ({
    type: UPDATE_COLLECTION_AFTER_SAVE,
    collection: collection,
}); };
export var removeCardsFromCollections = function (cardsIds) { return ({
    type: REMOVE_CARDS_FROM_COLLECTIONS,
    cardsIds: cardsIds,
}); };
export var setCollectionStatus = function (collectionId, status) { return ({
    type: SET_COLLECTION_PROGRESS_STATUS,
    collectionId: collectionId,
    status: status,
}); };
export var useCollectionProgress = function (idOrAlias, onFetchError) {
    var item = useSelector(function (state) {
        return collectionsProgressDetailsSelector(state, idOrAlias);
    });
    var isLoggedIn = useSelector(loggedSelector);
    var dispatch = useDispatch();
    useEffect(function () {
        if (idOrAlias) {
            dispatch(fetchCollectionProgressIfNeeded(idOrAlias)).catch(onFetchError || (function () { }));
        }
    }, [dispatch, item === null || item === void 0 ? void 0 : item.didInvalidate, idOrAlias, isLoggedIn, onFetchError]);
    return isProgressItemFetched(item) ? item : undefined;
};
function CardsCollectionsProgressReducer(state, action) {
    if (state === void 0) { state = cardsCollectionsProgressReducer.INITIAL_STATE; }
    if (action === void 0) { action = { type: undefined }; }
    return cardsCollectionsProgressReducer(state, action);
}
export default (_b = {}, _b[name] = CardsCollectionsProgressReducer, _b);
